import http from "../../http-commonv2";

const pit = () => {
  return http.get(`/api/v2/cdr/pit`);
};

const cdr = (data) => {
  return http.post(`/api/v2/cdr`, data);
};

const callRecording = (id) => {
  return http.get(`/api/v2/cdr/callRecording?id=${id}`, {
    responseType: "blob",
  });
};

const getTranscription = (id) => {
  return http.get(`/api/v2/cdr/getTranscription?id=${id}`);
};

const cdrEvents = (id) => {
  return http.get(`/api/v2/cdr/events?id=${id}`);
};

const downloadCsv = async (data) => {
  const response = await http.post(`/api/v2/cdr/downloadCsv`, data, {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "cdr_results.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadAgentSessions = async (data) => {
  const params = new URLSearchParams();

  if (data?.filters?.startDate) {
    params.append("initTime", data.filters.startDate);
  }

  if (data?.filters?.endDate) {
    params.append("endTime", data.filters.endDate);
  }

  const response = await http.get(
    `/api/v2/cdr/agent_sessions?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "agent_sessions.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const CdrService = {
  pit,
  cdr,
  downloadCsv,
  downloadAgentSessions,
  cdrEvents,
  callRecording,
  getTranscription,
};

export default CdrService;